<template>
	<lcsj-dialog v-model="showDialog" ref="processOutputDetailDialog" :title="'加工出库单详情 - ' + (detailData.outputStoreNo || '')" width="80%" append-to-body @close="closeDialog" cancel-text="关闭">
		<el-descriptions :column="3" border size="small" class="detail-desc">
			<el-descriptions-item label="出库单号">{{ detailData.outputStoreNo || "--" }}</el-descriptions-item>
			<el-descriptions-item label="出库方式">{{ detailData.outputTypeStr || "--" }}</el-descriptions-item>
			<el-descriptions-item label="出库状态">{{ detailData.stateStr || "--" }}</el-descriptions-item>
			<el-descriptions-item label="来源加工单号">{{ detailData.processOrderNo || "--" }}</el-descriptions-item>
			<el-descriptions-item label="收货门店">{{ detailData.belongStoreName || "--" }}</el-descriptions-item>
			<el-descriptions-item label="顾客">{{ detailData.customerName || "--" }}</el-descriptions-item>
			<el-descriptions-item label="出库人">{{ detailData.outputUserName || "--" }}</el-descriptions-item>
			<el-descriptions-item label="出库时间">{{ detailData.outputDate || "--" }}</el-descriptions-item>
			<el-descriptions-item label="作废时间">{{ detailData.cancelTime || "--" }}</el-descriptions-item>
			<el-descriptions-item label="备注" :span="3">{{ detailData.remark || "--" }}</el-descriptions-item>
		</el-descriptions>
		<div class="detail-block-title">出库明细</div>
		<el-table class="lcsj-data-table" :data="detailData.dtls || []" border size="small" style="width: 100%">
			<el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
			<el-table-column label="左右眼" width="80" align="center">
				<template #default="scope">{{ scope.row.lr === 1 ? "左眼" : "右眼" }}</template>
			</el-table-column>
			<el-table-column label="实际出库商品" min-width="200" align="center">
				<template #default="scope">
					<span>{{ scope.row.goodsName || "--" }}</span>
					<el-tag v-if="scope.row.isEditGoods" type="warning" size="mini" style="margin-left: 6px">已更换商品</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="更换前商品" min-width="180" align="center">
				<template #default="scope">{{ scope.row.isEditGoods ? scope.row.originGoodsName || "--" : "--" }}</template>
			</el-table-column>
			<el-table-column label="球镜" width="80" align="center" prop="qiuJing"></el-table-column>
			<el-table-column label="柱镜" width="80" align="center" prop="zhuJing"></el-table-column>
			<el-table-column label="轴位" width="70" align="center" prop="zhouWei"></el-table-column>
			<el-table-column label="出库数量" width="90" align="center" prop="quantity"></el-table-column>
			<el-table-column label="备注" min-width="140" align="center">
				<template #default="scope">{{ scope.row.remark || "--" }}</template>
			</el-table-column>
		</el-table>
		
	</lcsj-dialog>
</template>

<script>
import { GetProcessOutputStoreInfo } from "@/api/processApi.js";
export default {
	data() {
		return {
			showDialog: false,
			detailData: {}
		};
	},
	methods: {
		showSeeDetailDialog(row) {
			this.showDialog = true;
			GetProcessOutputStoreInfo({ keyId: row.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.detailData = res.data || {};
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		closeDialog() {
			this.showDialog = false;
			this.detailData = {};
		}
	}
};
</script>

<style scoped>
.detail-desc {
	margin-bottom: 12px;
}
.detail-block-title {
	margin: 10px 0;
	font-weight: 600;
}
</style>
